/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import EcgLoader from 'legacy/containers/EcgLoader';
import { Field, FieldArray, reduxForm, change, unregisterField } from 'redux-form'
import styles from './TkAndCrpForms.css'
import TextInput from '../../containers/Forms/components/CrpTextInput'
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import Loading from '../../components/Loading'
import ValidationRules from '../../components/CrpValidationRules'
import { emailMask,
  requiredValidation,
} from '../../containers/Forms/components/formValidations'
import { checkTKFeatureEnabled, checkCRPFeatureEnabled } from '../../../configs'
import pluseIcon from 'static/images/Vector.png'
import Typography from '@material-ui/core/Typography';
import FormSection from '../../../views/components/Common/FormSection/FormSection';
import { Box, Button } from '@material-ui/core';
import PassIcon from 'static/images/icons/checkbox-marked-circle-outline.svg'
import CheckedIcon from 'static/images/icons/checkboxCheckedSquare.svg'
import UncheckedIcon from 'static/images/icons/checkboxUncheckedSquare.svg'
import CheckedDisabledIcon from 'static/images/icons/checkboxCheckedDisableSquare.svg'
import RadioButtonInput from './components/RadioButtonInput';
import { FormattedMessage, useIntl } from 'react-intl'
const NewUpdatePasswordForm = props => {
  const intl = useIntl()
  const dispatch = useDispatch();
  const memberData= useSelector(state => state.app.dataSources.memberNotificationSettings)
  const {
    handleSubmit,
    handleInputChange,
    handleNotificationChange,
    validationTests,
    invalid,
    pristine,
    dirty,
    isSubmitting,
    submitting,
    pwError,
    pwErrorMsg,
    me,
    getAppointmentNotificationsSettings,
    onInfoSubmit,
    getMemberInfo,
    memberOnChangeInfo,
    getMe,
  } = props;
  // Constants to check telekardia enabled and user is admin or not
  const tkEnabled = checkTKFeatureEnabled(me)
  const crpEnabled = checkCRPFeatureEnabled(me)
  const isAdminEnabled = me && me.data && me.data.profile.permissions.isAdmin
  useEffect(() => {
    if (tkEnabled || crpEnabled) {
      getAppointmentNotificationsSettings()
      // !isAdminEnabled ? getMe() : ''
      getMemberInfo() // For getting member's data on my info page
    }
  }, [])
  const [currentPasswordInputType, setCurrentPasswordInputType] = useState('password')
  const [newPasswordInputType, setNewPasswordInputType] = useState('password')
  const [confirmPasswordInputType, setConfirmPasswordInputType] = useState('password')
  const togglePasswordInputType = (type, field) => {
    switch (field) {
      case 'currentPassword':
        setCurrentPasswordInputType(type === 'password' ? 'text' : 'password');
        break;
      case 'newPassword':
        setNewPasswordInputType(type === 'password' ? 'text' : 'password');
        break;
      case 'newPasswordConfirm':
        setConfirmPasswordInputType(type === 'password' ? 'text' : 'password');
        break;      
      default:
        break;
    }
  } 
  
  const getPasswordFieldIcon = (type) => type === 'password' ? <VisibilityIcon /> : <VisibilityOffIcon />

  return (
    <form
      onSubmit={handleSubmit}
      className={styles.updatePasswordForm}
      autoComplete="off"
      autoFocus={false}
    >
      <FormSection heading={<FormattedMessage id="tabs.label.Update_Password" />}>
        <div className={styles.formSectionRowStacked}>
          <div className={styles.formSectionRowStacked}>
            <div className={styles.passwordFieldWrapper}>
              <Typography variant="body1" className={styles.fieldText}>
                <FormattedMessage id="label.current" />
              </Typography>
              <Field
                component={TextInput}
                name="currentPassword"
                label={<FormattedMessage id="label.Password" />}
                type={currentPasswordInputType}
                validate={requiredValidation}
                onChange={handleInputChange}
                handleIconClick={togglePasswordInputType}
                icon={getPasswordFieldIcon(currentPasswordInputType)}
                id="currentPassword"
                autocomplete="currentPassword"
              />
            </div>
          </div>
          <div
            className={[styles.formSectionRow, styles.formSectionRowPwd].join(
              ' ',
            )}
          >
            <div
              className={[
                styles.formSectionRowStacked,
                styles.formSectionRowStackedPwd,
              ].join(' ')}
            >
              <div className={styles.passwordFieldWrapper}>
                <Typography variant="body1" className={styles.fieldText}>
                  <FormattedMessage id="label.new" />
                </Typography>
                <Field
                  component={TextInput}
                  name="newPassword"
                  label={<FormattedMessage id="label.Password" />}
                  type={newPasswordInputType}
                  validate={requiredValidation}
                  onChange={handleInputChange}
                  handleIconClick={togglePasswordInputType}
                  icon={getPasswordFieldIcon(newPasswordInputType)}
                  placeholder={intl.formatMessage({
                    id: 'placeholder.new_password'
                  })}
                />
              </div>
            </div>
            <div
              className={[
                styles.formSectionRowStacked,
                styles.formSectionRowStackedPwd,
              ].join(' ')}
            >
              <div className={styles.passwordFieldWrapper}>
                <Typography variant="body1" className={styles.fieldText}>
                  <FormattedMessage id="label.confirm_new" />
                </Typography>
                <Field
                  component={TextInput}
                  name="newPasswordConfirm"
                  label={<FormattedMessage id="label.Password" />}
                  type={confirmPasswordInputType}
                  validate={requiredValidation}
                  onChange={handleInputChange}
                  handleIconClick={togglePasswordInputType}
                  icon={getPasswordFieldIcon(confirmPasswordInputType)}
                  placeholder={intl.formatMessage({
                    id: 'placeholder.confirm_password'
                  })}
                />
              </div>
            </div>
            <div className={styles.buttonWrapper}>
            {submitting || isSubmitting ? (
                <button
                disabled
                className={styles.submitLoading}
                >
                <Loading />
                </button>
            ) : (
                <button
                type="submit"
                disabled={invalid || pristine}
                className={styles.submit}
                ><FormattedMessage id="tabs.label.Update_Password" />
                </button>
            )}
            </div>
        </div>
          <ValidationRules
            validationTests={validationTests}
            updatePassword={true}
            useGridLayout={true}
            passIcon={<PassIcon />}
            failIcon={<PassIcon />}
          />
          {pwError && (
            <div className={styles.pwValidationError}>{pwErrorMsg}</div>
          )}
        </div>
      </FormSection>
    </form>
  );
}
export default reduxForm({
  form: 'newUpdatePasswordForm',
  enableReinitialize: true,
})(NewUpdatePasswordForm)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/NewUpdatePasswordForm.jsx